"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultClassMetadata = getDefaultClassMetadata;
function getDefaultClassMetadata() {
    return {
        constructorArguments: [],
        lifecycle: {
            postConstructMethodNames: new Set(),
            preDestroyMethodNames: new Set(),
        },
        properties: new Map(),
        scope: undefined,
    };
}
//# sourceMappingURL=getDefaultClassMetadata.js.map